export default __webpack_public_path__ + "static/media/index.4ed85bb1.cjs";